import gql from 'graphql-tag';

/**
 * Data of the block project-technical-review-ac ("Techn. Prüfung - AC"): the four AC fields of
 * `technicalReview`, including the team info `installationTeamNotes`. Read through
 * `Project.blocks.technicalReviewAc`, which checks the block's read permission.
 */
export const PROJECT_TECHNICAL_REVIEW_AC_FIELDS = gql`
  fragment projectTechnicalReviewAcFields on ProjectTechnicalReviewAcBlock {
    id
    number
    technicalReview {
      acInspectedState
      acNotes
      expectedAcTimeExpenditureInSeconds
      installationTeamNotes
    }
  }
`;
